// @flow
'use strict';

import { connect } from 'react-redux';

import { fechaAlertas } from '../../../../../../reducers/modelo_relatorio/modal_lista_relatorios';

import Alertas from '../../common/alertas';

export default connect<*, *, *, *, *, *>(null, { fechaAlertas })(Alertas);
